import { Component, Input } from '@angular/core';

import { Subject } from 'rxjs';

/** This component displays the application footer */
@Component({
    selector: 'cw-footer',
    templateUrl: './main-notification-dialog.component.html',
    styleUrls: ['./main-notification-dialog.component.scss'],
    standalone: false,
})
export class MainNotificationDialogComponent {
    @Input() message: string | undefined;
    @Input() close$: Subject<void> | undefined;

    close(): void {
        this.close$?.next();
    }
}
